import React from 'react';
import DropdownPanel from '../../../../components/base/DropdownPanel';
import AddProductDialog from '../../../../components/products/AddProductDialog';
import OrderLines from '../../../../components/products/OrderLines';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from "../../../../state";
import { addProductsAndUpdateOrder, setDiscount, setProductAmount, setProductName, setProductPrice, updateOrder } from '../../../../state/order/action';
import { RootState, } from '../../../../state';
import { getOrder, getProductList, getProductSearchQuery } from '../../../../state/action';
import { updateProductSearchQuery } from '../../../../state/ui/action';
import { updateSearchList } from '../../../../state/product/action';
import { Checkbox, Stack } from '@fluentui/react';

interface OrderProductsProps {

    onRemoveProductWithProduct: (item: PurchaseItem) => void;
}

const OrderProducts: React.FC<OrderProductsProps> = (props) => {
    const dispatch = useDispatch<AppDispatch>();
    const order: Order = useSelector((state: RootState) => getOrder(state));
    const products = useSelector((state: RootState) => getProductList(state));
    const query = useSelector((state: RootState) => getProductSearchQuery(state));
    const onAddProducts = (items: PurchaseItem[]) => dispatch(addProductsAndUpdateOrder(order, items, order.debitor.no));

    const windowForPurchased = order.orderProperties && order.orderProperties.windowForPurchased;

    const onWindowForPurchasedClick = (event: React.MouseEvent<HTMLElement>, checked: boolean) => {
        dispatch(updateOrder({ ...order, orderProperties: { ...order.orderProperties, windowForPurchased: checked } }));
    }
    return (
        <DropdownPanel changed={false} title={"Vareliste"}>
            <div className="product_order__container">
                <OrderLines
                    useScrollableWrapper={true}
                    setDiscount={(itemNo, discount) => dispatch(setDiscount(itemNo, discount))}
                    removeProduct={props.onRemoveProductWithProduct}
                    setAmount={(amount, itemId) => dispatch(setProductAmount(amount, itemId))}
                    setPrice={(price, itemId) => dispatch(setProductPrice(price, itemId))}
                    setName={(name, itemId) => dispatch(setProductName(name, itemId))}
                    items={order.items}
                    orderStatus={order.additionalData.orderStatus}
                />
                <Stack horizontal>
                    <AddProductDialog
                        products={products}
                        updateSearchProductQuery={(query) => dispatch(updateProductSearchQuery(query))}
                        updateSearchList={(query, merge) => dispatch(updateSearchList({...query, excludePrice: true, firstRegistrationDate: order.car.firstRegistrationDate}, merge))}
                        query={query}
                        addProducts={onAddProducts}
                        orderStatus={order.additionalData.orderStatus}
                        debitorNo={order.debitor.no}
                    />
                   
                    <Checkbox className='checkbox_forPurchase' label="Til indkøb" checked={windowForPurchased} onChange={onWindowForPurchasedClick} />
                </Stack>
            </div>
        </DropdownPanel>
    );
};

export default OrderProducts;